<p-dialog [(visible)]="visibleLukiBannerModal" [modal]="true" [draggable]="false" [resizable]="false" position="center" (onHide)="closeModal()">
  <div class="dialog">
    <div class="container">
      <div class="dialog__info">
        <div class="bannerLuki">
          <div class="top">
            <div class="wrapper">
              <div class="image">
                <img src="assets/images/logos/luki-logo.png" alt="LUKI">
              </div>
              <div class="title">
                <h2>¡Luki facilitará el manejo de tu dinero!</h2>
              </div>
              <div class="description">
                <p>Luki es una innovadora plataforma digital, que te abre la puerta a un mundo de servicios financieros sin enredos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>